<template>
    <div class="animated fadeIn">
      <b-card v-if="is_published">
        <b-row>
          <b-col sm="6" style="cursor:pointer">
            <h3 @click="share">Shard your Service Production</h3>
          </b-col>
          <!-- <b-col sm="6">
            <b-button :variant="is_hide ? 'primary' : 'info' " @click="is_hide = !is_hide" class="pull-right m-2">{{is_hide ? 'Hide' : 'Show'}} Sales Margin</b-button>
          </b-col> -->
          <b-col>
            <!-- <span class="text-danger font-weight-bold">Auto hide your Sales Margin</span> -->
            <i style="cursor: pointer;" class="fa fa-share-alt cursor-pointer font-weight-bold pull-right mt-2" aria-hidden="true" @click="share"> Export to Image </i>
          </b-col>
        </b-row>
      </b-card>
      <b-row id="_share" class="text-center fadeIn fadeOut" v-show="is_published">
        <plan-card v-for="service in billing_now" v-bind:key="service.id" :service="service" :hide_margin="is_hide"></plan-card>
        <!-- <b-card-group class="text-center" deck>
        </b-card-group> -->
      </b-row>
      <b-card v-if="!is_published">
        <b-row>
          <b-col sm="12" class="text-center text-danger">
            <h3 class="text-dark">Check your plan info</h3>
            Please contact where you created the account you logged in to.
            <br>
            The currently logged-in account has no pricing information set
            <br>
            If you don't have pricing information, you can't attract
            <br>
            customers to your logged-in account
          </b-col>
        </b-row>
      </b-card>
    </div>
</template>
<script>


import { Api, auth } from '@/service';
import PlanCard from './PlanCard';
import _ from 'lodash';
import htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';


export default {
  components: { PlanCard },
  data : () => ({
    exporting : false,
    is_hide : false,
    billing_now : [],
    auth,
    model : { },
    is_published : true
  }),
  computed: {
  },
  methods: {
    async share() {
      try {
        if(this.exporting) { return; }
        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")
        this.exporting = true
        this.is_hide = false;
        let rs = await htmlToImage.toBlob(document.getElementById('_share'))
        saveAs(rs, auth.profile.username+'_service.png');
        this.exporting = false;
        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    async load() {
      try{
        let so = {
          target : 'partner.license', cmd : 'list',
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'partner_id', value : auth.profile.group_id, op : '='}, { name : 'is_alive', value : true, op : '=' }, { name : 'is_publish', value : true, op : '=' }] }
        }
        Api.Partner(so)
          .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason) } else { this.billing_now = (_.sortBy(rs.body, [(o) => o.base_price]) || []).map(r => { if(!r.is_publish && this.is_published) { this.is_published = false } r.add_price = r.add_price ? r.add_price : 0; return r  }); }})
          .catch(e => e.data.message ? this.$toastr.e(e.data.message, e.status, e.statusText) : console.error(e))
      } catch(e) { this.$toastr.e(e.data.message, e.status, e.statusText) }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params, from); } },
  created() { console.log('[Console] Billing System', 'created'); },
  destroyed() { console.log('[Console] Billing System', 'destroyed'); },
  mounted() { console.log('[Console] Billing System', 'mounted'); this.load(); },
}
</script>
